import React from "react";
import "./app.css";
import { getImage } from "../../../../../../utils/getImages";

const CashVoucherCard1 = ({ cardData, activetab }) => {
  return (
    <div className="col-md-12 py-5">
      <div id="icon-lists" className="row" style={{ marginTop: "20px" }}>
        {cardData?.dataArray?.map((item, index) => (
          <div className="col-3 col-md-3" key={index}>
            <div className="image-card">
              <img
                src={getImage(item?.image)}
                alt=""
                className="card-image"
              />
              <div className="overlay1 always-visible">
                <h5 className="overlay-title">
                  {activetab === "english"
                    ? item?.title
                    : activetab === "simplified_chinese"
                    ? item?.simplified_chinese_title
                    : activetab === "arabic"
                    ? item?.arabic_title
                    : activetab === "bahasa"
                    ? item?.bahasa_title
                    : item?.traditional_chinese_title}
                </h5>
                <div
                  className="overlay-description"
                  dangerouslySetInnerHTML={{
                    __html:
                      activetab === "english"
                        ? item?.description
                        : activetab === "simplified_chinese"
                        ? item?.simplified_chinese_description
                        : activetab === "arabic"
                        ? item?.arabic_description
                        : activetab === "bahasa"
                        ? item?.bahasa_description
                        : item?.traditional_chinese_description,
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CashVoucherCard1;
